import Axios from "../../axios";
const syncUserConfiguration = (
    state,
    work_site = localStorage.getItem("work_site") || "",
    funcAfterSync = () => {},
) => {
    const fetchData = async (dataUrl) => {
        let config = {};
        if (state) {
            config = {
                appointment_current_date: state?.currentDate,
                appointment_current_view_name: state?.currentViewName,
                appointment_main_resource_name: state?.mainResourceName,
                appointment_color_schema: state?.colorSchema,
                appointment_start_day_hour: parseInt(state?.startDayHour),
                appointment_end_day_hour: parseInt(state?.endDayHour),
                appointment_cell_duration: parseInt(state?.cellDuration),
                appointment_resource_employees:
                    state?.filterFactors?.employees_uuids,
                appointment_types: state?.filterFactors?.appointment_type,
                appointment_clinics: state?.filterFactors?.clinic,
                appointment_status: state?.filterFactors?.appointment_status,
            };
        } else {
            config = {
                appointment_current_date: JSON.parse(
                    localStorage.getItem("appointmentCurrentDate"),
                ),
                appointment_current_view_name: JSON.parse(
                    localStorage.getItem("appointmentCurrentViewName"),
                ),
                appointment_main_resource_name: JSON.parse(
                    localStorage.getItem("appointmentMainResourceName"),
                ),
                appointment_color_schema: JSON.parse(
                    localStorage.getItem("appointmentColorSchema"),
                ),
                appointment_start_day_hour: parseInt(
                    localStorage.getItem("appointmentStartDayHour"),
                ),
                appointment_end_day_hour: parseInt(
                    localStorage.getItem("appointmentEndDayHour"),
                ),
                appointment_cell_duration: parseInt(
                    localStorage.getItem("appointmentCellDuration"),
                ),
                appointment_resource_employees: JSON.parse(
                    localStorage.getItem("appointment_resource_employees"),
                ),
                appointment_types: JSON.parse(
                    localStorage.getItem("appointment_types"),
                ),
                appointment_clinics: JSON.parse(
                    localStorage.getItem("appointment_clinics"),
                ),
                appointment_status: JSON.parse(
                    localStorage.getItem("appointment_status"),
                ),
            };
        }
        try {
            await Axios.post(dataUrl, {
                configuration: {
                    ...config,
                    work_site: work_site,
                    displayModalAppendixOpen: JSON.parse(
                        localStorage.getItem("displayModalAppendixOpen"),
                    ),
                },
            });
            funcAfterSync();
        } catch (err) {
            console.error(err.message);
        }
    };
    fetchData(
        `${process.env.REACT_APP_API_BASE_URL}employee-scheduler-configuration/`,
    );
};
export const getUserConfig = () => {
    const fetchData = async (dataUrl) => {
        try {
            const response = await Axios.get(dataUrl);
            return response.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    };
    fetchData(
        `${process.env.REACT_APP_API_BASE_URL}employee-scheduler-configuration/`,
    );
};
export default syncUserConfiguration;
